// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedInflectionType {
  plural: {"enum_constant":"plural"};
}

export type InflectionTypeId = keyof IParsedInflectionType;
export type InflectionTypeData = IParsedInflectionType[InflectionTypeId];
const data: InflectionTypeData[] = [{"enum_constant":"plural"}];
export default data;
